module.exports = __webpack_public_path__ + "img/btn_menu_shjdh_c.375dc65d.png";